import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I track my order?",
      answer: "Once your order ships, you'll receive a shipping confirmation email with a tracking number. Click the tracking link in the email or enter the number on our carrier's website to track your package."
    },
    {
      question: "What is your return policy?",
      answer: "We offer a 30-day return policy. Items must be unworn, unwashed, and in original condition with tags attached. Contact our customer service team to initiate a return."
    },
    {
      question: "Do you ship internationally?",
      answer: "Yes! We ship worldwide. International shipping costs are calculated at checkout. Delivery times vary by location, typically 7-21 business days depending on your country."
    },
    {
      question: "How do I know what size to order?",
      answer: "Check our size guide for detailed measurements. If you're between sizes, we recommend sizing up. Our customer service team is happy to help with sizing questions."
    },
    {
      question: "When will my order ship?",
      answer: "Orders are processed within 1-2 business days. You'll receive a shipping confirmation email once your order has been dispatched. Standard shipping takes 5-7 business days within the US."
    },
    {
      question: "Can I change or cancel my order?",
      answer: "If you need to change or cancel your order, contact us immediately at orders@ditris.com. We'll do our best to accommodate requests, but once an order has shipped, it cannot be modified."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards (Visa, Mastercard, American Express, Discover), PayPal, Apple Pay, and Google Pay."
    },
    {
      question: "How do I care for my Dïtris products?",
      answer: "Care instructions are included on the garment tag. Generally, we recommend machine washing cold with like colors and tumble drying on low. Avoid bleach and harsh chemicals."
    },
    {
      question: "Do you offer gift cards?",
      answer: "Yes! Gift cards are available in denominations of $25, $50, $100, and $200. They never expire and can be used for any purchase on our website."
    },
    {
      question: "Are there any exclusions to the free shipping offer?",
      answer: "Free standard shipping applies to orders over $200 within the continental United States. Express and next-day shipping have additional fees. International orders have variable shipping costs."
    },
    {
      question: "How can I contact customer service?",
      answer: "You can reach us at support@ditris.com or call +1 (555) 123-4567. Our team is available Monday-Friday, 9am-6pm EST."
    },
    {
      question: "Do you restock sold-out items?",
      answer: "We try to restock popular items, but some pieces are limited edition. Sign up for email notifications on product pages to be alerted when items come back in stock."
    }
  ];

  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-medium tracking-wide mb-4">FREQUENTLY ASKED QUESTIONS</h1>
      <p className="text-gray-600 mb-8">Find answers to common questions about orders, shipping, and returns.</p>
      
      <div className="space-y-3">
        {faqs.map((faq, index) => (
          <div key={index} className="border border-gray-200">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
            >
              <span className="font-medium pr-4">{faq.question}</span>
              <ChevronDown
                size={20}
                className={`flex-shrink-0 transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="px-4 pb-4 text-sm text-gray-600 leading-relaxed">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-12 bg-gray-50 p-6 rounded">
        <h2 className="font-medium mb-2">Still have questions?</h2>
        <p className="text-sm text-gray-600 mb-3">
          Our customer service team is here to help.
        </p>
        <p className="text-sm">
          Email: <a href="mailto:support@ditris.com" className="underline">support@ditris.com</a><br />
          Phone: +1 (555) 123-4567
        </p>
      </div>
    </div>
  );
};

export default FAQ;